export default defineNuxtRouteMiddleware(to => {
  console.log('1_adminPage.ts')

  if (to.path === "/admin") {
    const { user: loggedUser, session: userData } = useUserSession()

    if (loggedUser.value?.role !== 'admin') {
      console.error('The user does not have admin rights')
      throw createError({
        statusCode: 403,
        statusMessage: 'The user does not have admin rights!'
      })
    }
  }

  return
})